<h1 mat-dialog-title class="p-2 text-center" i18n>Sélection d'un modèle de configuration </h1>
<div mat-dialog-content class="p-3">

    <div class="row align-items-center">
        <div class="col">
            <mat-form-field class="w-100">
                <mat-select i18n-placeholder placeholder="Configuration maître" [(ngModel)]="SelectedConfiguration">
                    @for (conf of AvailableConfigurationList; track conf.Code; let i = $index) {
                    <mat-option [value]="conf">
                        {{ conf.Name }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1 white" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()" i18n>
            Ajouter
        </button>
    </div>
</div>